import '../../confirmation-page.scss';
import './index.scss';
import React, { PropTypes } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { isUndefinedNullOrEmpty } from '../../../js/utils';
import { InputFieldWithValidation } from '../../common/FormComponents';
import { reliablyHandleAsyncFormSubmit } from '../../common/formUtils';
import { setImageName, startImagingOperation } from '../../../js/actions/imagingWorkflowActionCreators';
import { finishImagingWorkflow } from '../../../js/actions/workflowActionCreators';
import { imageCreationStatuses } from '../../../js/statuses';
import { hasValidLicence } from '../../../js/projections/licence';
import LoaderWithText from '../../common/LoaderWithText';
import FormErrorNotification from '../../common/FormErrorNotification';
import BackLink from '../../common/BackLink';
import classNames from 'classnames';
import { setTourEnabled } from '../../../js/actions/tourActionCreators';
import Joyride from 'react-joyride';
import { JoyrideStepStyle } from '../../common/Joyride/steps';

const steps = [{
    title: 'Give your image a name',
    text: 'Before creating your image you must give it a name. You can also check the settings you have chosen so far.', // supports html tags
    selector: '.operation-overview',
    position: 'left',
    type: 'hover',
    isFixed: true,
    style: JoyrideStepStyle,
}];

const validate = (values) => {
    const errors = {};

    if (isUndefinedNullOrEmpty(values.imagename)) {
        errors.imagename = 'Specify an image name.';
    }

    if (!isUndefinedNullOrEmpty(values.imagename) && values.imagename.length > 200) {
        errors.imagename = 'Image name cannot have more than 200 characters';
    }

    return errors;
};


let ImageCreationConfirmationPage = React.createClass({
    propTypes: {
        imageCreation: PropTypes.object.isRequired,
        isImageCreationCompleted: PropTypes.bool.isRequired,
        onImageCreationConfirm: PropTypes.func.isRequired,
        setImageCreationAsFinished: PropTypes.func.isRequired,
        storeFormData: PropTypes.func.isRequired,
        canCreate: PropTypes.bool.isRequired
    },
    componentWillReceiveProps: function (nextProps) {
        const { imageCreation, isImageCreationCompleted } = nextProps;
        if (isImageCreationCompleted) {
            browserHistory.push('/dashboard/images/' + imageCreation.operation.createdImageId + '?newImage=true');
        }
    },
    componentWillUnmount: function () {
        const { isImageCreationCompleted, setImageCreationAsFinished } = this.props;
        if (isImageCreationCompleted) {
            setImageCreationAsFinished();
        }
    },
    prepareImageCreationDataForDispatch: function (data) {
        const { imageCreation, onImageCreationConfirm, storeFormData } = this.props;
        return reliablyHandleAsyncFormSubmit(() => {
            storeFormData(data);
            const imageCreationData = {
                imageName: data.imagename,
                imageType: imageCreation.imageType,
                source:
                {
                    locationId: imageCreation.sourceLocation.id,
                    resourceNames: imageCreation.sourceLocation.resourceNames
                },
                destination:
                {
                    locationId: imageCreation.destinationLocation.id,
                    resourceNames: imageCreation.destinationLocation.resourceNames
                }
            };

            return onImageCreationConfirm(imageCreationData);
        });
    },
    tourCallback(value) {
        if (value && value.type === 'finished' && value.isTourSkipped) {
            this.props.setTourEnabled('dashboard', false);
            ga('send', 'event', {
                    eventCategory: 'tour',
                    eventAction: 'skippedImageConfirmation',
                    eventLabel: 'Skipped tour on image confirmation'
                });
        }
        if (value && value.type === 'finished' && !value.isTourSkipped) {
            ga('send', 'event', {
                    eventCategory: 'tour',
                    eventAction: 'finishedImageConfirmation',
                    eventLabel: 'End of image confirmation tour'
                });
        }
    },
    render: function () {
        const { imageCreation, sourceLocationDetails, handleSubmit, error, valid, pristine, canCreate } = this.props;
        const hasImageCreationStarted = imageCreation.operation.status !== imageCreationStatuses.initial;
        const hasImageCreationFailed = imageCreation.operation.status === imageCreationStatuses.failure;
        const isProcessing = hasImageCreationStarted && !hasImageCreationFailed;
        const sourceLocationClass = classNames(sourceLocationDetails.locationClassName, 'pure-u-3-4');
        const sourceResourcesClass = classNames(sourceLocationDetails.resourceClassName, 'pure-u-3-4');

        return <form onSubmit={handleSubmit(this.prepareImageCreationDataForDispatch)}>
            <div className="content-container">
                <Joyride ref="joyride" run={this.props.tourEnabled} autoStart={true} showSkipButton={true} type="continuous" steps={steps} callback={this.tourCallback} locale={{ last: 'Next', next: 'Next', skip: 'Skip', back: 'Back' }}/>
                <div className="form-container">
                    <FormErrorNotification error={error} />

                    <div className="image-review operation-overview">
                        <BackLink />
                        <h1>Review and create image</h1>
                        
                        <div className="confirmation-content pure-g">
                            <div className="confirm-row pure-u-1-1">
                                <div className="pure-u-1-1"><h4>{sourceLocationDetails.locationLabel}</h4></div>
                                <div className={sourceLocationClass}>{sourceLocationDetails.locationValue}</div>
                            </div>
                            <div className="confirm-row pure-u-1-1">
                                <div className="pure-u-1-1"><h4>{sourceLocationDetails.resourceNamesLabel}</h4></div>
                                <div className={sourceResourcesClass}>
                                    <ul className="database-list">
                                        {imageCreation.sourceLocation.resourceNames.map((name, i) => <li className="database-list-item" key={i}>{name}</li>)}
                                    </ul>
                                </div>
                            </div>
                            <div className="confirm-row pure-u-1-1">
                                <div className="pure-u-1-1"><h4>Image Destination</h4></div>
                                <div className="imageLocation pure-u-3-4">{imageCreation.destinationLocation.friendlyName}</div>
                            </div>
                            <div className="confirm-row pure-u-1-1">
                                <div className="pure-u-1-1"><h4>Image Name</h4></div>
                                <div className="imageName pure-u-3-4">
                                    <Field className="pure-input-1-2" name="imagename" type="text" autoFocus
                                        placeholder={'e.g. ' + imageCreation.sourceLocation.resourceNames[0] + ' after release 1.0'} component={InputFieldWithValidation} />
                                </div>
                            </div>
                        </div>

                        <div>
                            {isProcessing && <LoaderWithText loadingText="Creating" />}
                            <div className="button-holder">
                                <button type="submit" className="button button--primary header-button" disabled={isProcessing || !valid || pristine || !canCreate}>Create Image</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>;
    }
});

const getLocation = (state, id) => {
    const sqlServerLocation = state.sqlServerInstances.value.get(id);
    const backupLocation = state.backupLocations.value.get(id);
    return sqlServerLocation || backupLocation;
};

const getSourceDetails = (sourceLocation) => {
    return (sourceLocation.server) ?
        {
            locationLabel: 'Server instance',
            locationValue: sourceLocation.server + '\\' + sourceLocation.instance,
            resourceNamesLabel: 'Database',
            locationClassName: 'serverName',
            resourceClassName: 'databaseName',
        }
        :
        {
            locationLabel: 'Backup location',
            locationValue: sourceLocation.backupBasePath,
            resourceNamesLabel: 'Backup file name(s)',
            locationClassName: 'backupLocation',
            resourceClassName: 'backupFile',
        };
};

const mapStateToProps = (state) => {
    const { imageCreation } = state.app;
    const sourceLocation = getLocation(state, imageCreation.sourceLocation.id);
    return {
        canCreate: hasValidLicence(state),
        imageCreation: imageCreation,
        sourceLocationDetails: getSourceDetails(sourceLocation),
        isImageCreationCompleted: !isUndefinedNullOrEmpty(imageCreation) &&
        !isUndefinedNullOrEmpty(imageCreation.operation) &&
        !isUndefinedNullOrEmpty(imageCreation.operation.createdImageId),
        tourEnabled: state.tour.dashboard
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onImageCreationConfirm: (imageCreation) => {
            return dispatch(startImagingOperation(imageCreation));
        },
        storeFormData: (data) => {
            dispatch(setImageName(data.imagename));
        },
        setImageCreationAsFinished: () => {
            dispatch(finishImagingWorkflow);
        },
        setTourEnabled: (tour, enabled) => {
            dispatch(setTourEnabled(tour, enabled));
        }
        
    };
};

ImageCreationConfirmationPage = connect(mapStateToProps, mapDispatchToProps)(
    reduxForm({ form: 'ImageCreationConfirmationForm', validate: validate })(ImageCreationConfirmationPage)
);

ImageCreationConfirmationPage.title = 'Review';

export default ImageCreationConfirmationPage;



// WEBPACK FOOTER //
// ./src/components/imaging/ImageCreationConfirmationPage/index.jsx